import { useQuery } from '@tanstack/react-query';
import { getAcknowledgeAndVerifiedDetails } from 'services/reconciliationService';
import AcknowledgeAndVerifiedModel from 'models/audit/AcknowledgeAndVerifiedModel';

export function useAcknowledgeAndVerifiedDetails(storeId: string | null | undefined, date: string | null | undefined) {
    return useQuery<AcknowledgeAndVerifiedModel | null, Error>({
        queryKey: ['acknowledge-verified-details', storeId, date],
        queryFn: async () => {
            const response = await getAcknowledgeAndVerifiedDetails(storeId!, date!);
            if (response.success && response.data) {
                const data = Array.isArray(response.data) ? response.data[0] : response.data;
                return AcknowledgeAndVerifiedModel.fromServerData(data as any);
            }
            return AcknowledgeAndVerifiedModel.createEmpty();
        },
        enabled: !!storeId && !!date,
        retry: false
    });
}
